import { useQuery } from '@tanstack/react-query'
import { usersControllerGetUserInfo } from 'api.gen'

interface SuperAutorEligibility {
  super_autor_eligibility?: {
    eligible?: boolean
    has_criar_module?: boolean
    has_super_autor_flag?: boolean
    is_from_super_autor_origin?: boolean
  }
}

const fetchSuperAutorEligibility = async (): Promise<
  SuperAutorEligibility['super_autor_eligibility']
> => {
  const response = await usersControllerGetUserInfo()
  if (response.status === 200) {
    const data = response.data as unknown as SuperAutorEligibility
    return data.super_autor_eligibility ?? {}
  }
  return {}
}

export const useSuperAutorEligible = () => {
  const { data: eligibility = {} } = useQuery({
    queryKey: ['super-autor-eligible'],
    queryFn: fetchSuperAutorEligibility
  })

  const isSuperAutorEligible = eligibility?.eligible ?? false
  const hasCriarModuleAndFlag =
    (eligibility?.has_criar_module && eligibility?.has_super_autor_flag) ??
    false

  return { isSuperAutorEligible, hasCriarModuleAndFlag }
}
